import Vue from 'vue'
import Vuex from 'vuex'
import sliders from './modules/sliders'
import about from './modules/about'
import categories from './modules/categories'
import products from './modules/products'
import companyValues from './modules/companyValues'
import contacts from './modules/contacts'
import feedback from './modules/feedback'
import albums from './modules/albums'

Vue.use(Vuex)

export default new Vuex.Store({
	modules: {
		sliders,
		about,
		categories,
		products,
		companyValues,
		contacts,
		feedback,
		albums
	}
})
